import { Component } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { PboEmptyState } from '@bo-ui/pinata/empty-state';
import { SHELL } from './test-ids';

@Component({
  selector: 'amp-empty-page',
  template: `
    <pbo-empty-state
      pboIcon="inbox"
      [pboDescription]="'shell.empty.description' | transloco"
      [pboTestId]="testIds.EMPTY"
      [pboTitle]="'shell.empty.title' | transloco"
    />
  `,
  styleUrl: './shell-page.scss',
  imports: [PboEmptyState, TranslocoPipe],
})
export class AmpEmptyPage {
  readonly testIds = SHELL;
}
